import { Box } from "@mui/material"
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React from "react"
import { FacetType, SearchGlyphItem } from "src/generated/graphql"

import { s } from "../../../../utilities/common"

import { ResultItem } from "./ResultItem"

export const ResultList = ({
  results,
  facetType,
  selected,
}: {
  results?: SearchGlyphItem[]
  facetType: FacetType
  selected: string
}) => {
  const { ref, focusKey } = useFocusable()
  return (
    <Box sx={{ overflow: "hidden" }}>
      <FocusContext.Provider value={focusKey}>
        <Box
          id={"glyphResultList"}
          ref={ref}
          sx={{
            display: "flex",
            flexDirection: "column",
            ml: s("537px"),
            mt: s("42px"),
            width: s("846px"),
          }}
        >
          {results
            ? results.map((res, i) => (
                <ResultItem
                  key={"faceresult-" + selected + res.id + i}
                  scrollRef={ref}
                  result={res}
                  facetType={facetType}
                  glyph={selected}
                />
              ))
            : null}
        </Box>
      </FocusContext.Provider>
    </Box>
  )
}
